module.exports = __webpack_public_path__ + "static/media/mobile.157c25bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/article-redesign/mobile.png
// module id = 81
// module chunks = 0